import React from 'react';
import {WithTranslation} from 'react-i18next';
import {get} from 'lodash';

import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
interface Generation {
  isFrontline: boolean;
  level: number;
}

interface Item {
  generation: Generation;
}

interface ClientRoleProps extends WithTranslation {
  item: Item | null;
  isCABReport: boolean;
}

export const ClientRole: React.FC<ClientRoleProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
  isCABReport = false,
}) => {
  const generation = get(item, 'generation', {});
  const {isFrontline, level} = generation;

  if (isFrontline) {
    return isCABReport
      ? tt('frontline', 'Frontline')
      : tt('frontline', 'Client · Frontline');
  } else {
    return tt(
      'roleDescription',
      generateComponentCallback({
        component: isCABReport ? (
          <>Generation {level}</>
        ) : (
          <>Client · GEN{level}</>
        ),
      }),
    );
  }
};

export default withTranslation('report.record.clientRole')(ClientRole);
